import React from 'react';
import './style.css';

/**
 * YoutubeEmbed - A component to embed YouTube videos
 * @param {Object} props
 * @param {string} props.embedId - The YouTube video ID
 * @param {string} [props.status] - Optional status class for styling
 */
const YoutubeEmbed = ({ embedId, status = '' }) => {
    return (
        <div className={`youtube-embed ${status}`}>
            <iframe
                src={`https://www.youtube.com/embed/${embedId}`}
                title="Embedded youtube"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                loading="lazy"
            />
        </div>
    );
};

export default YoutubeEmbed;
